import { LazyLoad } from '@petconsole/pure-fe-mui';

const PclService = LazyLoad(() => import('./PclServiceApp'));
const PclServices = LazyLoad(() => import('./PclServicesApp'));

export { PclService, PclServices }